<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.poPickup')" type="confirm" width="70%" @confirm="confirm">
    <vxe-card>
      <template #title>
        <vxe-input v-model="parameter['order.no']" placeholder="business.label.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="parameter['supplier.name']" placeholder="business.label.supplierName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="parameter['item.filter']" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="parameter.range" linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh" @clear="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="orderTable" :data="orders" :loading="loading" @cell-click="({row})=>onOrderSelect(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.orderNo" width="130"/>
        <vxe-column field="supplier.name" title="business.label.supplier"/>
        <vxe-column field="invoiceTime" title="business.label.invoiceDate" width="170"/>
        <vxe-column field="operator" title="business.label.operator" width="80"/>
        <vxe-column field="buyer" title="business.label.buyer" width="80"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="owner.name" title="business.label.owner" width="120"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :pageSizes="[5, 10, 15, 20]" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <vxe-card>
      <vxe-table
        ref="detailsTable"
        :data="details"
        :edit-config="{}"
        keep-source
        max-height="600"
        min-height="200">
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="250"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="180"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="lotNo" title="business.label.lotNo" width="120"/>
        <vxe-column field="productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column :edit-render="{name:'VxeNumberInput',props:{min:1}}" field="plannedQuantity" title="business.label.quantity" width="100"/>
        <vxe-column field="number" title="business.label.number" width="60"/>
        <vxe-column field="numberOfEach" title="business.label.numberOfEach" width="70"/>
      </vxe-table>
    </vxe-card>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import api from '@/api'
import { findAll, post } from '@/api/Api'
import { AsnDetail, AsnOrder } from '@/api/dto/order/AsnOrder'
import { PurchaseOrder } from '@/api/dto/order/PurchaseOrder'
import moment from 'moment/moment'

export default {
  name: 'PoModal',
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      visible: false,
      loading: false,
      order: new AsnOrder(),
      orders: [],
      details: [],
      purchaseOrder: new PurchaseOrder(),
      purchaseDetails: [],
      parameter: {
        refundable: false,
        completed: false,
        draw: false,
        extracted: false,
        'order.no': '',
        'item.filter': '',
        'supplier.name': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      page: 1,
      size: 5,
      contentSize: 0
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    onOrderSelect(row) {
      this.purchaseOrder = new PurchaseOrder(row)
      this.details = row['details']
      if (this.details) {
        this.details.forEach(dtl => {
          this.onQuantityChanged(dtl)
        })
      }
      this.$nextTick(() => {
        this.$refs.orderTable.setCurrentRow(row)
        this.$refs.detailsTable.setAllCheckboxRow(true)
      })
    },
    onQuantityChanged(target) {
      target.number = Math.floor(target.plannedQuantity / target.pack.factor)
      target.numberOfEach = target.plannedQuantity - target.number * target.pack.factor
    },
    open(order) {
      this.visible = true
      if (order) {
        this.order = order
        this.parameter['orderType.ids'] = [order.orderType.id]
        this.parameter['owner.id'] = order.owner.id
        this.parameter['supplier.id'] = order.customer.id
      } else {
        this.parameter['orderType.ids'] = undefined
        this.parameter['owner.id'] = undefined
        this.parameter['supplier.id'] = undefined
      }
      this.reset()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.parameter)
      if (args.range.length !== 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('receivingPoPickupFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.orders = res.result
          if (this.orders.length > 0) {
            this.onOrderSelect(this.orders[0])
          } else {
            this.details = []
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.parameter['order.no'] = ''
      this.parameter['item.filter'] = ''
      this.parameter['supplier.name'] = ''
      this.parameter.range = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      this.purchaseOrder = new PurchaseOrder()
      this.purchaseDetails = []
      this.refresh()
    },
    confirm() {
      this.purchaseDetails = []
      this.$refs.detailsTable.getCheckboxRecords().forEach(item => {
        const detail = Object.assign({}, item)
        detail.id = null
        detail.purchaseDetail = {
          id: item.id
        }
        this.purchaseDetails.push(detail)
      })
      if (this.order.isNew()) {
        this.buildOrder()
        this.save()
      } else {
        const that = this
        this.$confirm({
          title: '检测到主界面存在ASN单:' + this.order.no,
          content: '是否追加提取',
          onOk() {
            that.save()
          },
          onCancel() {
            that.buildOrder()
            that.save()
          },
          okText: '追加提取',
          cancelText: '生成新单',
          centered: true
        })
      }
    },
    buildOrder() {
      this.order = new AsnOrder()
      this.order.orderType = this.purchaseOrder.orderType
      this.order.owner = this.purchaseOrder.owner
      this.order.customer = this.purchaseOrder.supplier
      this.order.address = this.purchaseOrder.address
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.warehouse = this.warehouse
      order.details = this.purchaseDetails.map(item => {
        const detail = new AsnDetail(item)
        detail.id = undefined
        detail.version = undefined
        detail.quantity = item.plannedQuantity
        detail.purchaseDetail = item.purchaseDetail
        return detail.toJSONObject()
      })
      post(api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success', res.result)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>